import axios from 'axios';
import { MembershipTypeS } from '../../Membership/outbound/share';
import { ProductListTypeS } from '../outbound/share';
import {
  PaginatedProductListResponse,
  ProductCardViewData,
  ProductCardListData,
  ProductIncludeOption,
  ProductResponse,
  ShopProductListFetchOption,
  UserLikedProductListFetchOption,
} from '../type';
import { UtilS } from '../../../../../modules/Util/S/Function/module/UtilS';
import { makeApiUrl } from '../../../shared/util';
import { BestProductQueryParams } from '../validate/best_product';

export const getPaginatedProductListApi = async (
  option: ShopProductListFetchOption,
): Promise<PaginatedProductListResponse> => {
  const { data } = await axios.get<PaginatedProductListResponse>(`/${T.lang}/@api/products/page`, {
    params: option,
  });
  return data;
};

/**
 * `products.id`로 상품 하나만 조회하는 api 입니다.
 */
export const getProductApi = async (id: number, option?: ProductIncludeOption): Promise<ProductResponse> => {
  const { data } = await axios.get<ProductResponse>(`/${T.lang}/@api/products/${id}`, {
    params: option,
  });
  return data;
};

const getUserLikeUrl = () => {
  if (UtilS.isMarppleShopApp()) {
    return `/${T.lang}/@api/user_like_products`;
  }
  if (UtilS.isNessApp()) {
    return `/${T.lang}/@api/my_like/products`;
  }

  // 나중에 서비스 또 추가되면 활용하게 될 것 같으나 우선 이렇게..
  return `/${T.lang}/@api/my_like/products`;
};

export const getUserLikeProductListApi = async (
  option: UserLikedProductListFetchOption,
): Promise<ProductCardViewData[]> => {
  const { data } = await axios.get<ProductCardListData>(getUserLikeUrl(), {
    params: option,
  });

  return data.products || data;
};

export const getBestProductListApi = async (option: BestProductQueryParams) => {
  const { data } = await axios.get<{
    products: ProductCardViewData[];
    updated_at: Date | null;
  }>(`/${T.lang}/@api/best_products`, {
    params: option,
  });
  return data;
};

export const getMembershipProductListApi = async (
  option: MembershipTypeS.CreatorShopMembershipProductListRetrieveOption & {
    store_id: number;
  },
): Promise<{ count: number; products: ProductListTypeS.ProductCardViewData[] }> => {
  const { data: membership_product_data } = await axios.get<{
    count: number;
    products: ProductListTypeS.ProductCardViewData[];
  }>(`/${T.lang}/@api/products/membership/${option.store_id}`, {
    params: option,
  });
  return membership_product_data;
};

export const getRecentlySoldProductsApi = async ({ last_ordered_at }: { last_ordered_at: Date }) => {
  const { data } = await axios.get<{ products: ProductCardViewData[] }>(
    makeApiUrl(`/:lang/@api/products/recently`, { lang: ET.lang }),
    {
      params: {
        last_ordered_at,
      },
    },
  );
  return data.products;
};
